import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';
import Document from "./Document";
import GridConfig from "./GridConfig";

export default class JournalReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true,
			fromDate: null,
			toDate: null,
			accountId: null,
			type: 1,
			configName: 'journal_report'
		}
	}
	componentDidMount() {
		this.getData();
	}
	getData() {
		this.httpPost("api/v1/report/journal", {type: this.state.type})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	showDocument(id) {
		this.showComponents({ component: <Document Caller={this} Id={id} /> });
	}
	showDocument(id) {
		this.showComponents({ component: <Document Caller={this} Id={id} /> });
	}
	onGridConfig() {
		this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
	}
	getDefaultConfig() {
		return {
			name: this.state.configName,
			fields: [
				{ field: "dateString", caption: "تاریخ", show: true },
				{ field: "documentNumber", caption: "سند", show: true },
				{ field: "code", caption: "کدحساب", show: true },
				{ field: "name", caption: "نام حساب", show: true },
				{ field: "description", caption: "شرح", show: true },
				{ field: "bed", caption: "بدهکار", show: true },
				{ field: "bes", caption: "بستانکار", show: true },
			]
		}
	}
	getColumns() {
		var config = this.getGridConfig();
		var t = [];
		config.fields.forEach(f => {
			if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'documentNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showDocument(props.data.documentId)}>{props.data.documentNumber}</a> } });
			if (f.field == 'code' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'description' && f.show) t.push({ field: f.field, headerName: f.caption });
			if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
			if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
		});
		return t;
	}
	renderForm() {
		return <div className="container">
			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-info">
						<div className="panel-body">
							<div className="col-sm-3">
								دفتر روزنامه
							</div>
							<div className="col-sm-6 text-center" style={{ "display": "flex", "place-content": "center" }}>
								<div className="col-sm-4 text-center mr-b-5">
									<select className="form-control" defaultValue={this.state.type} onChange={e => this.state.type = parseInt(e.target.value)}>
										<option value="1">همه تراکنش ها</option>
										<option value="2">تراکنش های دستی</option>
										<option value="3">تراکنش های اتوماتیک</option>
									</select>
								</div>
								از
								<DatePicker
									inputReadOnly={true}
									className="range-from-example text-center mr-l-5 mr-r-5"
									style={{ border: "solid 1px #ccc" }}
									placeholder={"تاریخ"}
									isGregorian={false}
									showTodayButton={true}
									timePicker={false}
									onChange={(e) => { this.state.fromDate = e }}
									value={this.getFormatedDateForDatePicker(this.state.fromDate)}
								/>
								تا
								<DatePicker
									inputReadOnly={true}
									className="range-to-example text-center mr-r-5"
									style={{ border: "solid 1px #ccc" }}
									placeholder={"تاریخ"}
									isGregorian={false}
									showTodayButton={true}
									timePicker={false}
									onChange={(e) => { this.state.toDate = e }}
									value={this.getFormatedDateForDatePicker(this.state.toDate)}
								/>
								<a className="hand mr-r-5" onClick={e => this.getData()}><i className="fa fa-search"></i></a>
							</div>
							<div className="col-sm-3 text-left">
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPrint('دفتر روزنامه')} title="چاپ">
									<span className="fa fa-print"></span>
								</button>
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf('دفتر روزنامه')} title="PDF">
									<span className="fa fa-file-pdf-o"></span>
								</button>
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel('دفتر روزنامه')} title="اکسل">
									<span className="fa fa-file-excel-o"></span>
								</button>
								<a className="btn btn-no-frame btn-smoke btn-sm pull-left" onClick={e => this.onGridConfig()} title="تنظیمات نمایش">
									<span className="fa fa-cog"></span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			{this.renderAgGrid({
				columnDefs: this.getColumns()
			})}
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				this.renderPopupComponent(),
				<Footer />
			];

		return contents;
	}
}